import { styled } from '../stitches.config';
import { rem } from '../util';

export const Columns = styled('div', {
  display: 'grid',
  columnGap: rem(32),

  variants: {
    gap: {
      16: {
        columnGap: rem(16),
      },
      32: {
        columnGap: rem(32),
      },
    },
    layout: {
      '1-1-1': {
        gridTemplateColumns: '1fr 1fr 1fr',
      },
      '1-1-1-1': {
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
      },
      '1-1': {
        gridTemplateColumns: '1fr 1fr',
      },
      '1-3': {
        gridTemplateColumns: `${rem(232)} ${rem(776)}`,
      },
      '1-2_5': {
        gridTemplateColumns: `${rem(288)} ${rem(720)}`,
      },
      '3-1': {
        gridTemplateColumns: `${rem(712)} ${rem(296)}`,
      },
      '7-6': {
        gridTemplateColumns: '7fr 6fr',
      },
      '8-5': {
        gridTemplateColumns: '8fr 5fr',
      },
    },
  },
});

export const Column = styled('div', {});

export const Row = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  variants: {
    spaceBetween: {
      true: {
        justifyContent: 'space-between',
      },
    },
    spaceAround: {
      true: {
        justifyContent: 'space-around',
      },
    },
  },
});

export const Box = styled('div', {});

export const Fixed = styled('div', {
  position: 'fixed',
  width: '100%',
});

export const RowMobileColumn = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  '@sm': {
    flexDirection: 'column',
  },
  variants: {
    spaceBetween: {
      true: {
        justifyContent: 'space-between',
      },
    },
    spaceAround: {
      true: {
        justifyContent: 'space-around',
      },
    },
    alignItem: {
      center: {
        alignItems: 'center',
      },
    },
  },
});
